import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, input } from '@angular/core';

import { TidyUiComponentsModule } from 'src/tidy-ui-components/tidy-ui-components.module';

import { PLATFORM_COVERAGE, PLATFORM_LABELS, PLATFORMS } from './booking-settings.model';

/**
 * Per-platform coverage markers for one setting: a pill per OTA channel the setting is
 * pushed to, read from PLATFORM_COVERAGE. Renders nothing for a setting that reaches
 * every channel — the pills flag the exceptions, not the rule — unless `showAll` asks
 * for every channel to be named (the Listing Builder labels each field that way).
 */
@Component({
  selector: 'platform-pills',
  standalone: true,
  imports: [TidyUiComponentsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: `
    @for (p of platforms(); track p) {
      <span class="pp-pill"><tidy-text [body]="labels[p]" /></span>
    }
  `,
  styles: [`
    platform-pills:empty { display: none; }
    platform-pills { display: inline-flex; align-items: center; gap: 4px; }
    .pp-pill {
      border: 1px solid var(--tidy-border-light);
      border-radius: 999px;
      padding: 1px 8px;
      white-space: nowrap;
      .body-text { font-size: 11px; color: var(--tidy-text-light); }
    }
  `],
})
export class PlatformPillsComponent {
  /** The setting key, as sent to the API. */
  readonly key = input.required<string>();

  readonly showAll = input(false);

  readonly labels = PLATFORM_LABELS;

  readonly platforms = computed(() => {
    const channels = PLATFORM_COVERAGE[this.key()] ?? [];
    return channels.length === PLATFORMS.length && !this.showAll() ? [] : channels;
  });
}
